import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";
import CustomError from "../../Utils/Domain/CustomError";

export async function verifyMFA({ code }) {
  try {
    const email = new Storage("mfa_email").getItem();
    const session = new Storage("mfa_session").getItem();
    const response = await new API(URL.buildUrl("mfa")).post({
      email,
      session,
      code,
    });
    const { token, id } = response.data;
    new Storage("token").setItem(token);
    new Storage("id").setItem(id);
    new Storage("mfa_email").removeItem();
    new Storage("mfa_session").removeItem();
    return response;
  } catch (error) {
    throw new CustomError(error);
  }
}

export async function resendMFA() {
  try {
    const email = new Storage("mfa_email").getItem();
    const session = new Storage("mfa_session").getItem();
    const response = await new API(URL.buildUrl("mfa")).put({
      email,
      session,
    });
    if (response?.data?.session) {
      new Storage("mfa_session").setItem(response.data.session);
    }
    return response;
  } catch (error) {
    throw new CustomError(error);
  }
}
